import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router, ActivatedRoute} from '@angular/router';
import {APP_CONFIG} from '@synthroneApp/app.config';

import {MatDialog} from '@angular/material';
import {AlertComponent} from '@angular/synthrone-design/components';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';

@Component({
    selector: 'app-attributes-groups-view',
    templateUrl: './attributes-groups-view.component.html',
    styleUrls: ['./attributes-groups-view.component.scss']
})

export class AttributesGroupsViewComponent implements OnInit {

    @ViewChild('table') table;

    configColumns = {
        name: {
            label: 'Name',
            sortable: true,
            truncate: true
        },
        "attributes.length": {
            label: 'Number of attributes',
            sortable: false,
            truncate: false
        }
    };

    constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog, private messagesService: MessagesService) {
    }

    ngOnInit() {
    }

    add = () => {
        this._router.navigate(['/attributes-groups/add']);
    };

    editRow = (key) => {
        this._router.navigate(['/attributes-groups/edit', key]);
    };

    deleteRow = (key) => {
        const dialogRef = this.dialog.open(AlertComponent, {
            data: {
                message: 'Are you sure that you want to delete this attributes group?'
            }
        }).afterClosed().subscribe(result => {
            if (result == 'proceed') {
                this.api.makeRequest('api_system_attribute_group_delete', {
                    id: key
                }, 'crafter').subscribe(
                    (result) => {
                        if (this._router.url === '/attributes-groups') {
                            this.table.getData();
                        } else {
                            this._router.navigate(['/attributes-groups']);
                        }
                    },
                    (error) => {
                        this.messagesService.showSnack(error, 'error');
                    }
                );
            }
        });
    };

    getTableData = (limit, offset, sortBy, sortOrder): Observable<any> => {
        return this.api.makeRequest('api_system_attribute_group_list', {
            seed: new Date().getTime(),
            offset: offset,
            limit: limit,
            sortBy: sortBy,
            sortOrder: sortOrder
        }, 'crafter');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/views/attributes-groups-view/attributes-groups-view.component.ts